import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c6c7ff52"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hd-epic-splash" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hd-epic-splash__bg" }, null, -1))
const _hoisted_3 = { class: "hd-epic-splash__container hd-container" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hd-epic-splash__separator" }, null, -1))
const _hoisted_5 = { class: "hd-epic-splash__bottom-info" }
const _hoisted_6 = { class: "hd-epic-splash__links" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hd-epic-splash__links-bg" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hd-epic-splash__links-icon" }, null, -1))
const _hoisted_9 = { class: "hd-epic-splash__links-container" }
const _hoisted_10 = ["href"]
const _hoisted_11 = { class: "hd-epic-splash__info" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lyra_asset = _resolveComponent("lyra-asset")!
  const _component_base_image_svg = _resolveComponent("base-image-svg")!
  const _component_base_button = _resolveComponent("base-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_lyra_asset, {
        class: "hd-epic-splash__title",
        "asset-key": "epic-hr-splash-title"
      }),
      _createVNode(_component_lyra_asset, {
        class: "hd-epic-splash__subtitle",
        "asset-key": "epic-hr-splash-subtitle"
      }),
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links, (link) => {
              return (_openBlock(), _createElementBlock("a", {
                key: link.id,
                class: "hd-epic-splash__links-item",
                href: link.url
              }, [
                _createVNode(_component_lyra_asset, {
                  "asset-key": `epic-hr-splash-link-${link.id}`
                }, null, 8, ["asset-key"])
              ], 8, _hoisted_10))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_lyra_asset, { "asset-key": "epic-hr-splash-bottom-info" })
        ])
      ]),
      _createVNode(_component_base_button, {
        callback: _ctx.switchScreen,
        callbackString: "timeline",
        modifier: "border-white"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_lyra_asset, { "asset-key": "epic-hr-splash-button-start" }),
          _createVNode(_component_base_image_svg, {
            source: require('!html-loader!../assets/images/chevron-circle-up-icon.svg')
          }, null, 8, ["source"])
        ]),
        _: 1
      }, 8, ["callback"])
    ])
  ]))
}